import React, { useEffect } from 'react';
import {
  getConfigFile,
  handleUserSession,
  getTempConfigFile,
  getUsers
} from '../actions';
import { connect } from 'react-redux';
import { LinearProgress } from '@material-ui/core';
import HeatMap from '../components/heatmap';

const MetricsContainer = state => {
  const appName = state.configFile?.name;
  useEffect(() => {
    const loadDashboard = async () => {
      const token = await handleUserSession();
      token &&
        Promise.all([
          state.ConfigFile(token),
          state.TempConfigFile(token),
          state.UsersList(token)
        ]);
    };
    loadDashboard();
    // eslint-disable-next-line
  }, []);

  if (!state.configFile || !state.tempConfigFile || !state.users) {
    return <LinearProgress />;
  }
  return (
    <>
      {state.configFile.trackingInfo
        ? <HeatMap appName={appName} />
        : null}
    </>
  )
  ;
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile,
    users: state.users
  };
};

const mapDispatchToPropsActions = dispatch => ({
  ConfigFile: token => dispatch(getConfigFile(token)),
  TempConfigFile: token => dispatch(getTempConfigFile(token)),
  UsersList: token => dispatch(getUsers(token))
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsActions
)(MetricsContainer);
